<template>
  <div>
    <div class="box" v-for="(_mrtOptRow, idx) in dataList.__mtrOptions">
      <div v-for="(item, index) in dataList.questionDetails.issue.rows" :key="index">
        <h1 class="mini-question-description" v-if="_mrtOptRow.row_id == item.row_id">
          <span class="___img-class" v-html="transformHtml(item.content.richText || item.content.text)"></span>
          <!-- <el-image
            v-if="getImg(item)"
            style="width: 30px; height: 30px;"
            :z-index="5000"
            :src="getImg(item)"
            :preview-src-list="[getImg(item)]"
            /> -->
        </h1>
      </div>
      <el-checkbox-group
        @input="updateMatrixMultiple(dataList)"
        v-model="dataList.__matrixMultiple[_mrtOptRow.row_id].answers"
        style="display: flex; align-items: center"
      >
        <el-checkbox
          v-for="item of dataList.questionDetails.issue.items"
          :key="item.id"
          :label="item.id"
          style="display: flex; align-items: center"
        >
          <span
            class="___img-class"
            style="min-width: 100px; white-space: normal"
            v-html="transformHtml(item.content.richText || item.content.text)"
          ></span>
          <!-- <el-image
            v-if="getImg(item)"
            style="width: 30px; height: 30px;"
            :z-index="5000"
            :src="getImg(item)"
            :preview-src-list="[getImg(item)]"
            /> -->
        </el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
import { getImg, saveArr } from '../public/index.js'
import { itemInitOptions } from '../config/config.js'
import mixins from '../mixins'

export default {
  mixins: [mixins],
  name: 'MatrixMultipleChoice',
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 需要更新的 数组
    updateArr: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      dataList: []
    }
  },
  created() {
    this.initData_6(this.rowData)
    this.dataList = Object.assign({}, this.rowData)
  },
  inject: ['transformHtml'],
  methods: {
    initData_6(item) {
      if (item.questionType === 6) {
        let newMatrixMultiple = {}
        // 初始化
        item.questionDetails.issue.rows.forEach(r => {
          newMatrixMultiple[r.row_id] = {
            title: '',
            answers: []
          }
        })
        // 填充答案
        item.items.forEach(it => {
          if (newMatrixMultiple[it.rowId]) {
            newMatrixMultiple[it.rowId].answers.push(it.colId)
          }
        })
        item.__matrixMultiple = newMatrixMultiple

        // 整理选项
        let __mtrOptions = []
        item.questionDetails.issue.rows.map(r => {
          __mtrOptions.push(r)
          r.cols = []
          item.questionDetails.issue.items.map(col => {
            r.cols.push(JSON.parse(JSON.stringify(col)))
          })
        })
        item.__mtrOptions = __mtrOptions
      }
    },
    updateMatrixMultiple(row) {
      row.items = []
      for (let [rowId, { title, answers }] of Object.entries(row.__matrixMultiple)) {
        answers.forEach(colId => {
          if (colId) {
            row.items.push(
              Object.assign({}, itemInitOptions, {
                colId,
                rowId,
                value: row.questionDetails.issue.items.find(it => it.id && it.id === colId).content.text
              })
            )
          }
        })
      }
      // if(this.updateArr.findIndex(it => it.questonId === row.questonId) === -1){
      //   this.updateArr.push(row);
      // }
      this.saveArr(this.dataList)
    },
    getImg,
    saveArr
  }
}
</script>

<style lang="scss">
.___img-class {
  img {
    width: 20px !important;
    height: 20px !important;
  }
}
</style>
